import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Loader from "components/atoms/Loader";
import Title from "components/atoms/Title";
import Assessment from "components/molecules/Assessment";
import StudentInfo from "components/molecules/StudentInfo";

import {
  useGetSessionInfoQuery,
  useStartGuestSessionMutation,
} from "generated/graphql";

import useClickOutside from "hooks/clickOutSide";

import { assessments } from "./data";
import {
  Container,
  Muted,
  Content,
  TopContainer,
  AssessmentList,
  MobileHeader,
  DesktopOnly,
  MobileOnly,
} from "./styles";

const FreeTest = () => {
  const { t } = useTranslation();

  const { data: sessionInfo, loading, refetch } = useGetSessionInfoQuery();

  const [startGuestSession] = useStartGuestSessionMutation();

  const { ref: containerRef } = useClickOutside();

  useEffect(() => {
    if (!loading && !sessionInfo?.getSessionInfo?.isGuest) {
      startGuestSession();
      refetch();
    }
  }, [sessionInfo, startGuestSession, refetch, loading]);

  if (loading) return <Loader />;

  return (
    <Container>
      <TopContainer ref={containerRef}>
        <Title style={{ marginBottom: "0" }}>
          <Muted>{t("user.hi")},</Muted> Guest!
        </Title>
      </TopContainer>
      <Content>
        <DesktopOnly>
          <StudentInfo
            welcomeText="Here are your available assessments"
            finished={false}
            studentId=""
            reportName=""
            isTutorialButtonVisible={false}
            isFreeTest
            isInterestInventoryFinished={false}
          />
        </DesktopOnly>
        <AssessmentList>
          <MobileOnly>
            <MobileHeader>{t("student.assessments")}</MobileHeader>
          </MobileOnly>
          {assessments.map((assessment, index) => (
            <Assessment
              key={index}
              {...assessment}
              id={index.toString()}
              isFreeTest
            />
          ))}
        </AssessmentList>
      </Content>
    </Container>
  );
};

export default FreeTest;
